var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-card",
    [
      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("edit-block")))]),
      _c(
        "w-card-content",
        [
          _c(
            "w-row",
            [
              _c(
                "w-col",
                { attrs: { xs: "12" } },
                [
                  _c("w-input", {
                    attrs: { fancy: "", label: _vm.$ct("common.name") },
                    model: {
                      value: _vm.block.Name,
                      callback: function ($$v) {
                        _vm.$set(_vm.block, "Name", $$v)
                      },
                      expression: "block.Name",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-sortable",
        {
          attrs: {
            tag: "w-list",
            items: _vm.block.Lines,
            "target-class": "handle",
          },
        },
        [
          _vm._l(_vm.block.Lines, function (line, i) {
            return _c(
              "w-list-item",
              { key: line.key, attrs: { "show-handle": "" } },
              [
                _c("w-list-item-text", [
                  _vm._v(_vm._s(line.getAsText(_vm.model))),
                ]),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-line-conditions"),
                            expression: "$ct('edit-line-conditions')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            _vm.editConditionsLineIndex = i
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "filter" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("copy-styles-to-all-lines"),
                            expression: "$ct('copy-styles-to-all-lines')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.copyStyleToAllLines(line)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "clone" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("edit-line"),
                            expression: "$ct('edit-line')",
                          },
                        ],
                        on: {
                          click: function ($event) {
                            return _vm.editLine(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "pen" } })],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "w-list-item-action",
                  [
                    _c(
                      "w-button",
                      {
                        directives: [
                          {
                            name: "tooltip",
                            rawName: "v-tooltip",
                            value: _vm.$ct("delete-line"),
                            expression: "$ct('delete-line')",
                          },
                        ],
                        staticClass: "danger",
                        on: {
                          click: function ($event) {
                            return _vm.deleteLine(i)
                          },
                        },
                      },
                      [_c("w-fa", { attrs: { icon: "trash" } })],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            )
          }),
          _c(
            "w-list-item",
            {
              on: {
                click: function ($event) {
                  return _vm.addNewLine()
                },
              },
            },
            [
              _c(
                "w-list-item-icon",
                [_c("w-fa", { attrs: { icon: "plus" } })],
                1
              ),
              _c("w-list-item-text", [_vm._v(_vm._s(_vm.$ct("add-line")))]),
            ],
            1
          ),
        ],
        2
      ),
      _vm.toEditLine
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-text-line-settings", {
                attrs: {
                  value: _vm.toEditLine,
                  layout: _vm.layout,
                  model: _vm.model,
                },
                on: {
                  input: function ($event) {
                    return _vm.onTextLineInput($event)
                  },
                  close: function ($event) {
                    _vm.toEditLineIndex = -1
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.editConditionsLine
        ? _c("app-conditions-edit-modal", {
            attrs: {
              value: _vm.editConditionsLine.Conditions,
              fields: _vm.conditionsPropSelectGroup,
            },
            on: {
              close: function ($event) {
                _vm.editConditionsLineIndex = -1
              },
              input: function ($event) {
                return _vm.onConditionsInput($event)
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }